export default "__VITE_ASSET__DUfnbkb1__"